var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('youtube',{staticClass:"text-center",attrs:{"video-id":_vm.videoId,"player-vars":{ autoplay: 1, rel: 0 }},on:{"ready":_vm.ready}})}
var staticRenderFns = []
export { render, staticRenderFns }